/* ============================================================ */
/*  Maamitahara collection CTA                                   */
/*  - Quantity selector (- / +): adjusts the item quantity       */
/*  - Add to cart: adds the selected quantity + goes to /cart    */
/* ============================================================ */

(function () {
  'use strict';

  var CART_URL = '/cart';

  function cards() {
    return Array.prototype.slice.call(document.querySelectorAll('.mma-collection-card'));
  }

  function cardState(card) {
    return {
      card: card,
      available: card.getAttribute('data-available') === 'true',
      variantId: card.getAttribute('data-variant-id'),
      cartBtn: card.querySelector('[data-maa-add-cart]'),
      hiddenId: card.closest('form') ? card.closest('form').querySelector('input[name="id"]') : null,
      qtyInput: card.querySelector('[data-maa-qty-input]'),
      minusBtn: card.querySelector('[data-maa-qty-minus]'),
      plusBtn: card.querySelector('[data-maa-qty-plus]'),
      weightPrice: card.querySelector('[data-maa-price]'),
      weightOptions: Array.prototype.slice.call(card.querySelectorAll('[data-maa-weight-option]')),
      imageLink: card.closest('.card') ? card.closest('.card').querySelector('.card__media-link') : null
    };
  }

  function setCardAvailability(state, available) {
    state.available = available;
    state.card.setAttribute('data-available', available ? 'true' : 'false');

    if (state.cartBtn) {
      if (available) {
        state.cartBtn.removeAttribute('disabled');
      } else {
        state.cartBtn.setAttribute('disabled', '');
      }
      var text = state.cartBtn.querySelector('.mma-card__buy-text');
      if (text) text.textContent = available ? 'Add to cart' : 'Sold out';
    }

    if (state.qtyInput) {
      if (available) {
        state.qtyInput.removeAttribute('disabled');
        state.qtyInput.closest('[data-maa-qty]').style.pointerEvents = '';
        state.qtyInput.closest('[data-maa-qty]').style.opacity = '';
      } else {
        state.qtyInput.setAttribute('disabled', '');
        if (state.qtyInput.closest('[data-maa-qty]')) {
          state.qtyInput.closest('[data-maa-qty]').style.pointerEvents = 'none';
          state.qtyInput.closest('[data-maa-qty]').style.opacity = '0.55';
        }
      }
      if (state.minusBtn) available ? state.minusBtn.removeAttribute('disabled') : state.minusBtn.setAttribute('disabled', '');
      if (state.plusBtn) available ? state.plusBtn.removeAttribute('disabled') : state.plusBtn.setAttribute('disabled', '');
    }
  }

  function selectWeight(state, btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var available = btn.getAttribute('data-available') === 'true';

    // update selected styling
    state.weightOptions.forEach(function (b) {
      b.classList.toggle('is-selected', b === btn);
    });

    // update variant id everywhere
    state.variantId = variantId;
    state.card.setAttribute('data-variant-id', variantId);
    if (state.hiddenId) {
      state.hiddenId.value = variantId;
      if (available) {
        state.hiddenId.removeAttribute('disabled');
      } else {
        state.hiddenId.setAttribute('disabled', '');
      }
    }

    // update price
    if (state.weightPrice) {
      state.weightPrice.textContent = btn.getAttribute('data-price-formatted') || '';
    }

    setCardAvailability(state, available);
  }

  function getQuantity(state) {
    if (!state.qtyInput) return 1;
    var val = parseInt(state.qtyInput.value, 10);
    if (isNaN(val) || val < 1) val = 1;
    state.qtyInput.value = val;
    return val;
  }

  function changeQuantity(state, delta) {
    if (!state.qtyInput) return;
    var current = getQuantity(state);
    var min = parseInt(state.qtyInput.min, 10) || 1;
    var max = state.qtyInput.max ? parseInt(state.qtyInput.max, 10) : Infinity;
    var next = current + delta;
    if (next < min) next = min;
    if (next > max) next = max;
    state.qtyInput.value = next;
  }

  function setButtonLoading(button, on, busyText, idleText) {
    if (!button) return;
    button.classList.toggle('is-loading', on);
    button.setAttribute('aria-disabled', on ? 'true' : 'false');
    var text = button.querySelector('.mma-card__buy-text');
    if (text && busyText && idleText) text.textContent = on ? busyText : idleText;
  }

  function addVariantToCart(variantId, quantity) {
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', String(quantity || 1));

    return fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body
    })
      .then(function (res) {
        return res.json().catch(function () {
          return {};
        });
      })
      .then(function (data) {
        if (data && data.status && data.status !== 'ok') {
          throw new Error(data.description || data.message || 'add to cart failed');
        }
        return data;
      });
  }

  /* Add to cart -> add selected quantity, then go to cart */
  function addToCart(event, state) {
    event.preventDefault();
    event.stopPropagation();
    if (!state.available || !state.variantId) return;

    var quantity = getQuantity(state);
    setButtonLoading(state.cartBtn, true, 'Adding…', 'Add to cart');

    addVariantToCart(state.variantId, quantity)
      .then(function () {
        window.location.href = CART_URL;
      })
      .catch(function () {
        setButtonLoading(state.cartBtn, false, 'Adding…', 'Add to cart');
      });
  }

  function bind() {
    var all = cards();
    if (!all.length) return;

    all.forEach(function (card) {
      var state = cardState(card);

      if (state.imageLink) {
        state.imageLink.addEventListener('click', function (event) {
          var href = state.imageLink.getAttribute('href');
          if (!href) return;
          event.preventDefault();
          window.location.href = href;
        });
      }

      if (state.cartBtn) {
        state.cartBtn.addEventListener('click', function (event) {
          addToCart(event, state);
        });
      }

      if (state.minusBtn) {
        state.minusBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          changeQuantity(state, -1);
        });
      }

      if (state.plusBtn) {
        state.plusBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          changeQuantity(state, 1);
        });
      }

      if (state.qtyInput) {
        state.qtyInput.addEventListener('change', function () {
          getQuantity(state);
        });
      }

      state.weightOptions.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          selectWeight(state, btn);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
